import * as InfoMessages from './InfoMessages.css';
export default {
    InfoMessages
};
